<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <donation-campaign-form :route="route" @on-submit="onCampaignSubmit"></donation-campaign-form>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Select, Option } from 'element-ui'
import DonationCampaignForm from './DonationCampaignForm.vue'

Vue.use(Select)

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    DonationCampaignForm
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      campaignModel: {}
    }
  },
  methods: {
    onCampaignSubmit (model) {
      this.campaignModel = model
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/DonationCampaigns/DonationCampaignAdd.vue